import React, { useEffect, useMemo, useState } from "react";
import { v4 } from "uuid";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { CircularProgress, InputAdornment, TextField } from "@mui/material";
import { Toaster } from "react-hot-toast";
import { DataGrid } from "@mui/x-data-grid";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import exportExcel from "utils/excelGenerate";
import { getTaskStats, getVisitsStats } from "_controllers/officer";
import { toastMessage } from "utils/toastMessage";

const Main = () => {
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [taskData, setTaskData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = useMemo(() => [
    {
      field: "SAP_ID",
      headerName: "SAP ID",
      flex: 1,
    },
    {
      field: "zone",
      headerName: "Zone",
      flex: 1,
    },
    {
      field: "region",
      headerName: "Region",
      flex: 2,
    },
    {
      field: "area",
      headerName: "Area",
      flex: 2,
    },
    {
      field: "Completed",
      headerName: "Completed",
      flex: 1,
    },
    {
      field: "WIP",
      headerName: "WIP",
      flex: 1,
    },
    {
      field: "Pending",
      headerName: "Pending",
      flex: 1,
    },
  ]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(async () => {
    await getTaskStats()
      .then((d) => {
        const test = d?.taskStats.map((user) => ({
          id: v4(),
          SAP_ID: user.SAP_ID,
          zone: user.zone ? user.zone : "-",
          region: user.regionName ? user.regionName : "-",
          area: user.areaName ? user.areaName : "-",
          territory: user.territoryName ? user.territoryName : "-",
          Completed: user?.stats?.Completed || 0,
          WIP: user?.stats?.WIP || 0,
          Pending: user?.stats?.["To Be Started"] || 0,
        }));
        setTaskData(test);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(false);
        toastMessage("error fetching data", "error");
      });
  }, []);

  useEffect(() => {
    const res = taskData
      .filter(
        (data) =>
          data?.SAP_ID?.toUpperCase().includes(search.toUpperCase()) ||
          data?.zone?.toUpperCase().includes(search.toUpperCase()) ||
          data?.region?.toUpperCase().includes(search.toUpperCase()) ||
          data?.area?.toUpperCase().includes(search.toUpperCase())
      )
      .map((user) => ({
        id: user?.id,
        SAP_ID: user.SAP_ID,
        zone: user.zone ? user.zone : "-",
        region: user.region ? user.region : "-",
        area: user.area ? user.area : "-",
        territory: user.territory ? user.territory : "-",
        Completed: user?.Completed || 0,
        WIP: user?.WIP || 0,
        Pending: user?.Pending || 0,
      }));
    setSearchData(res);
  }, [search]);

  let fileName = "Task-Stats";

  const generateExcel = async (e) => {
    e.preventDefault();
    exportExcel(
      taskData.map((x) => ({
        "SAP ID": x?.SAP_ID,
        Zone: x?.zone,
        Region: x?.region,
        Area: x?.area,
        Completed: x?.Completed,
        WIP: x?.WIP,
        Pending: x?.Pending,
      })),
      fileName
    );
  };

  return (
    <>
      <div style={{ width: "98%", marginTop: "2.5rem", marginBottom: "2rem" }}>
        {/* <Grid>
          <h2>Visit Stats</h2>
        </Grid> */}
        <div
          style={{
            paddingBottom: "1rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center ",
          }}
        >
          <TextField
            onChange={handleChange}
            value={search}
            name="search"
            variant="outlined"
            label="SAP ID or Territory"
            // fullWidth
            sx={{ width: "93%" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <DownloadIcon
            sx={{
              border: "1px solid darkgrey",
              fontSize: "55px",
              borderRadius: "3px",
              cursor: "pointer",
            }}
            onClick={generateExcel}
          />
        </div>

        {loading ? (
          <CircularProgress />
        ) : (
          <DataGrid
            rows={search ? searchData : taskData}
            columns={columns}
            autoHeight={true}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            className="TableCell"
            rowsPerPageOptions={[10, 25, 50, 100]}
            sx={{ fontSize: "0.75rem" }}
          />
        )}
      </div>
      <Toaster />
    </>
  );
};

const TaskStats = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default TaskStats;
